<script>
import AdminLayout from '@layouts/admin-main'
import Statistic from '@components/admin/statistic'

export default {
  page: {
    title: 'Admin::Statistic',
    meta: [{ name: 'description', content: 'Admin::Statistic' }],
  },
  components: { AdminLayout, Statistic },
}
</script>

<template>
  <AdminLayout>
    <Statistic></Statistic>
  </AdminLayout>
</template>
